import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M8.354 11.182L6.94 12.596A2.501 2.501 0 013.404 9.06l2.121-2.12a2.5 2.5 0 013.536 0l.708.706"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M7.647 4.818l1.414-1.415a2.501 2.501 0 013.536 3.536l-2.121 2.122a2.5 2.5 0 01-3.536 0l-.708-.708"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M12.53 16.774l-2.121 2.12a3.752 3.752 0 01-5.304-5.303l3.182-3.181a3.75 3.75 0 015.304 0l1.06 1.06"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M11.47 7.227l2.12-2.122a3.752 3.752 0 015.305 5.304l-3.182 3.182a3.75 3.75 0 01-5.304 0l-1.061-1.06"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M25.06 33.547l-4.241 4.242a7.503 7.503 0 01-10.608 0 7.503 7.503 0 010-10.608l6.364-6.362a7.5 7.5 0 0110.608 0l2.122 2.12"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M22.94 14.454l4.241-4.244a7.503 7.503 0 0110.608 0 7.503 7.503 0 010 10.608l-6.364 6.364a7.5 7.5 0 01-10.608 0l-2.122-2.122"
  }))
};
export var Link = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});